import React from "react";
import Blog_50_10 from "../component/Blog_50_10";
function Blog_50_10_container() {
  return <Blog_50_10 />;
}

export default Blog_50_10_container;
